function join(array: string[], splitter: string = '\n'): string {
    return array.join(splitter);
}

export default join;
